import { IconNames } from './icon-names';

export enum TransportMode {
  Road = 'ROAD',
  Sea = 'SEA',
  Rail = 'RAIL',
  Air = 'AIR',
  Unknown = 'UNKNOWN',
}

export const ShipmentTransportMode: {
  Rail: TransportMode;
  Road: TransportMode;
  Air: TransportMode;
  Sea: TransportMode;
} = {
  Road: TransportMode.Road,
  Sea: TransportMode.Sea,
  Rail: TransportMode.Rail,
  Air: TransportMode.Air,
};

export const TRANSPORT_MODE_ICONS_MAP = new Map<
  TransportMode,
  IconNames.PlaneSide | IconNames.Train | IconNames.Logistics | IconNames.Ship
>([
  [TransportMode.Air, IconNames.PlaneSide],
  [TransportMode.Rail, IconNames.Train],
  [TransportMode.Road, IconNames.Logistics],
  [TransportMode.Sea, IconNames.Ship],
]);
